module.exports = __webpack_public_path__ + "img/home.77de252b.png";